import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";
import { trans } from "../i18n/i18n";

export async function requestVehicleReport(vin) {
    return (await axiosInstance.post(route("jsapi.order.vehicleReport"), { vin }, {
        toastMsg: trans("An error occurred while processing your request. Please try again later."),
    })).data;
}
